import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { RichTextSection } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

import {
  PageHeader,
  ContentImage,
  RelatedItemInEvidence,
  SkipToMainContent,
  ContentTypeViewSections,
  useSideMenu,
  Metadata,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const Default = ({ content }) => {
  const language = content.language?.token || 'it';
  const data_validita =
    content.data_validita &&
    new Date(content.data_validita).toLocaleDateString(language, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  return (
    <RichTextSection
      tag_id="default"
      title="Offerta di lavoro"
      field="descrizione_estesa"
    >
      <RichTextSection
        data={content.descrizione_estesa}
        field="descrizione_estesa"
        title=""
        show_title={false}
      />

      <div className="mt-0 mb-5">
        <h5>Riferimento N°</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.numero_riferimento}
        </div>

        <h5>Offerta valida fino al</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">{data_validita}</div>

        <h5>Servizio di riferimento</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.servizio_riferimento?.title}
        </div>

        <h5>Posizione ricercata</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.posizione_ricercata}
        </div>
      </div>
    </RichTextSection>
  );
};

const Details = ({ content }) => {
  return (
    <RichTextSection tag_id="details" title="Informazioni offerta">
      <div className="mt-0 mb-5">
        <h5>Luogo di lavoro</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.luogo_lavoro?.title}
        </div>

        <h5>Qualifica</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.qualifica?.title}
        </div>

        <h5>Numero di posti</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.numero_posti}
        </div>

        <h5>Attività azienda</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.attivita_azienda?.title}
        </div>

        <h5>Tipo di rapporto</h5>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {content.tipo_rapporto?.title}
        </div>

        {content.ral && (
          <>
            <h5>Retribuzione</h5>
            <div className="d-flex flex-wrap gap-2 mb-3">{content.ral}</div>
          </>
        )}

        {content.esperienza !== undefined && (
          <>
            <h5>Richiesta esperienza</h5>
            <div className="d-flex flex-wrap gap-2 mb-3">
              {content.esperienza ? 'Sì' : 'No'}
            </div>
          </>
        )}

        {content.anni_settore && (
          <>
            <h5>Anni nel settore</h5>
            <div className="d-flex flex-wrap gap-2 mb-3">
              {content.anni_settore}
            </div>
          </>
        )}

        {content.anni_mansione && (
          <>
            <h5>Anni nella mansione</h5>
            <div className="d-flex flex-wrap gap-2 mb-3">
              {content.anni_mansione}
            </div>
          </>
        )}

        {content.posizione_riservata && (
          <>
            <h5>Posizione riservata Legge 68</h5>
            <div className="d-flex flex-wrap gap-2 mb-3">
              {content.posizione_riservata ? 'Sì' : 'No'}
            </div>
          </>
        )}
      </div>
    </RichTextSection>
  );
};

const OffertaLavoroViewSectionsOrder = () => [
  { /* DEFAULTS */ component: Default },
  { /* DETAILS */ component: Details },
];

const OffertaLavoroView = ({ content }) => {
  const documentBody = createRef();
  const { sideMenuElements, SideMenu } = useSideMenu(content, documentBody);
  return (
    <>
      <div className="container px-4 my-4 offertalavoro-view">
        <SkipToMainContent />
        <PageHeader
          content={content}
          readingtime={null}
          showreadingtime={false}
          showdates={false}
          showtassonomiaargomenti={true}
        />

        {/* <ContentImage content={content} position="afterHeader" /> */}

        <div className="row row-column-border border-light row-column-menu-left">
          <aside className="col-lg-4 ">
            <SideMenu data={sideMenuElements} content_uid={content?.UID} />
          </aside>
          <section
            id="main-content-section"
            className="col-lg-8 it-page-sections-container border-light"
            ref={documentBody}
          >
            <ContentTypeViewSections
              content={content}
              defaultSections={OffertaLavoroViewSectionsOrder()}
            />
            <Metadata content={content} showTags={false} title=""></Metadata>
          </section>
          {/* <pre>{JSON.stringify(content, null, 4)}</pre> */}
        </div>
      </div>

      <RelatedItemInEvidence content={content} />
    </>
  );
};

OffertaLavoroView.propTypes = {
  content: PropTypes.object.isRequired,
};

export default OffertaLavoroView;
